import { Button } from '@chakra-ui/react'
import Avatar from 'components/MainApp/Profile/Avatar'
import { PROTECTED } from 'lib/routes'
import React from 'react'
import { Link } from 'react-router-dom'

const User = ({ user }) => {
    return (
        <div>
            <Avatar user={user}/>
            <p>{user.name} {user.lastname}</p>
            <p>@{user.username}</p>
            <Button
                as={Link}
                to={`${PROTECTED}/profile/${user.id}`}

            >View Profile</Button>
        </div>
    )
}

export default User